import { render, staticRenderFns } from "./cleaningTask.vue?vue&type=template&id=7123ca48&scoped=true"
import script from "./cleaningTask.vue?vue&type=script&lang=js"
export * from "./cleaningTask.vue?vue&type=script&lang=js"
import style0 from "./cleaningTask.vue?vue&type=style&index=0&id=7123ca48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7123ca48",
  null
  
)

export default component.exports